import React from 'react';
import { ActiveAuction } from 'src/lib/GlobalDataContext';
import { MegaMenuCurrentAuctionCard } from './MegaMenuCurrentAuctionCard';
import { MegaMenuUpcomingAuction } from './MegaMenuUpcomingAuction';
import { MegaMenuSectionTitle } from './MegaMenuSectionTitle';
import { MegaMenuLink } from 'src/components/Header/components/MegaMenu/MegaMenuLink';
import { cn, IconExternalLink, TextLink, Typography } from '@up-riac/bespoke-ui';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuAuctionsPage = ({ currentAuctions, upcomingAuctions, pastAuctions }: {currentAuctions: ActiveAuction[], upcomingAuctions: ActiveAuction[], pastAuctions: ActiveAuction[]}) => {
  const { megaMenuState } = useMegaMenu();
  return (
    <div className={cn(
      'grid gap-5 xl:gap-10',
      'grid-cols-1 lg:grid-cols-4 py-5'
    )}>
      <div className={cn(
        'flex flex-col gap-3',
        'lg:col-span-2'
      )}>
        <MegaMenuSectionTitle title='Current Auctions' to='/gun-auctions#current'/>
        <div className='flex flex-row gap-3 justify-around lg:justify-start'>
          {currentAuctions.length === 0 && (
            <div>
              <Typography
                color='text-lightest'
                className='italic'
                size='sm'
              >
                No current auctions scheduled at this time. Be the first to know about our new auctions.
              </Typography>
              <TextLink
                to='https://rockislandauction.us13.list-manage.com/subscribe?u=ade8396c719b3abbeacf57a7e&id=1f4b8db853&ref=rockislandauction.com'
                color='text'
                UNSAFE_className='font-bold text-xs'
              >
                Get notified <IconExternalLink className='size-4 mt-0.5'/>
              </TextLink>
            </div>
          )}
          {currentAuctions.map((auction, index) => (
            <div key={auction.AuctionID} className='flex flex-col gap-2' id={`mega-menu-active-auction-${index}`}>
              <MegaMenuCurrentAuctionCard auction={auction} />
            </div>
          ))}
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <MegaMenuSectionTitle title='Upcoming Auctions' to='/gun-auctions#upcoming'/>
        <div className='flex flex-col gap-3'>
          {upcomingAuctions.length === 0 && (
            <div>
              <Typography
                color='text-lightest'
                className='italic'
                size='sm'
              >
                No upcoming auctions at this time. Be the first to know about our new auctions.
              </Typography>
              <TextLink
                to='https://rockislandauction.us13.list-manage.com/subscribe?u=ade8396c719b3abbeacf57a7e&id=1f4b8db853&ref=rockislandauction.com'
                color='text'
                UNSAFE_className='font-bold text-xs'
              >
                Get notified <IconExternalLink className='size-4 mt-0.5'/>
              </TextLink>
            </div>
          )}
          {upcomingAuctions.slice(0, 3).map((auction, i) => (
            <div key={auction.AuctionID} className='flex flex-col gap-4'>
              <MegaMenuUpcomingAuction auction={auction} index={i}/>
            </div>
          ))}
        </div>
      </div>
      <div className='flex flex-col gap-3'>
        <MegaMenuSectionTitle title='Past Auctions' to='/gun-auctions#past'/>
        <div className='flex flex-col gap-3'>
          {pastAuctions.map((auction, i) => (
            <div key={auction.AuctionID} className='flex flex-col gap-4'>
              <MegaMenuLink
                to={`/catalog/${auction.AuctionID}`}
                onPress={megaMenuState.close}
                label={auction.Title}
                id={`mega-menu-past-auction-${i + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
